<template>
  <div v-focustrap class="modal-frame" :class="{ _center: center }">
    <div class="modal-frame__overlay" @click="onOverlayClicked" />

    <div class="modal-frame__inner" :class="`_${size}`">
      <slot v-bind="{ close }" />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    size?: string;
    backdropClose?: boolean;
    escClose?: boolean;
    center?: boolean;
  }>(),
  {
    size: 'md',
    backdropClose: false,
    escClose: false,
    center: false
  }
);

const $modal = inject('$modal', {
  close: (...args: any) => args
});

const close = (...args: any) => {
  $modal.close(...args);
};

const onOverlayClicked = () => {
  if (props.backdropClose) {
    close(false);
  }
};

const onEscapePressed = (e: KeyboardEvent) => {
  if (e.key === 'Escape') {
    close(false);
  }
};

onMounted(() => {
  if (props.escClose) {
    document.addEventListener('keydown', onEscapePressed);
  }
});

onUnmounted(() => {
  document.removeEventListener('keydown', onEscapePressed);
});
</script>

<style lang="postcss">
.modal-frame {
  @apply absolute inset-x-0 -bottom-4 -top-4 z-[1] flex items-center justify-center py-4;

  &._center {
    @apply items-center;
  }

  &__overlay {
    @apply absolute inset-0 bg-black opacity-30;
  }

  &__inner {
    @apply relative;

    &._xs {
      @apply w-[360px];
    }

    &._sm {
      @apply w-[480px];
    }

    &._md {
      @apply w-[826px];
    }

    &._xl {
      @apply w-[1024px];
    }

    &._2xl {
      @apply w-[1200px];
    }

    &._3xl {
      @apply w-[1400px];
    }

    &._full {
      @apply w-[96%];
    }
  }
}
</style>
